<template>
  <div @touchstart.once="audioPlay" id="main" class="zaozigongfang">
    <banner></banner>
    <div class="box">
      <citySwiper @switch-city="switchCity"></citySwiper>
      <div class="lotteryBox">
        <div @click="share" v-maidian="'shareBtn'" class="shareIcon">
          <img
            src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/update/share.png"
          />
        </div>
        <svg
          v-if="audioPlayStatus"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          t="1646646108014"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          p-id="3599"
          style="
            enable-background: new 0 0 200 406;
            width: 30px;
            opacity: 0.5;
            position: fixed;
            right: 20px;
            top: 50px;
            z-index: 99;
          "
          @click="stop"
        >
          <path
            d="M525.541411 131.503033l-230.494605 148.031475h-114.988917c-63.895239 0-115.679649 51.14996-115.679649 115.219161v230.898811c0 63.664995 51.150984 115.219161 115.679649 115.219161h114.988917l230.494605 147.915841c32.582069 14.128789 57.840336-0.980327 57.840336-33.04358V164.54559c0-32.120558-25.892717-46.825468-57.840336-33.042557z m194.223516 186.033997c-10.841929-11.649318-29.122271-12.283768-40.712237-1.384533-11.649318 10.899234-12.226462 29.122271-1.384533 40.770565 5.363148 5.76633 14.531971 18.511609 23.989367 37.772279 16.146749 32.870642 25.892717 71.449285 25.892717 115.507733 0 44.058448-9.745968 82.694397-25.892717 115.507734-9.457396 19.259646-18.626219 32.004925-23.989367 37.772278-10.899234 11.648294-10.264784 29.871331 1.384533 40.770566 11.648294 10.899234 29.871331 10.264784 40.770566-1.384533 9.054213-9.68764 21.509896-26.987654 33.620725-51.727105 19.895119-40.483017 31.774681-87.654362 31.774681-140.996245 0-53.341882-11.879562-100.514251-31.774681-140.996244-12.169157-24.62484-24.625864-41.983183-33.679054-51.612495z m176.806845-35.69599c-23.297612-39.444361-46.825468-66.778916-63.318094-81.483826-11.880585-10.609639-30.102598-9.572006-40.714284 2.36486-10.609639 11.936867-9.573029 30.101575 2.364861 40.712238 2.709715 2.421142 8.131191 7.842619 15.396665 16.261358 12.455683 14.416338 24.911366 31.601742 36.619012 51.439556 33.504068 56.860009 53.630455 123.349329 53.630455 199.066825s-20.126386 142.206816-53.68776 199.125153c-11.706623 19.836791-24.220634 37.022195-36.619012 51.438533-7.265474 8.41874-12.68695 13.840216-15.397689 16.261359-11.879562 10.610662-12.916171 28.833699-2.363837 40.714283 10.553357 11.879562 28.833699 12.916171 40.713261 2.363838 16.493649-14.70491 40.021505-41.98216 63.319117-81.483826 38.522362-65.336054 61.646012-141.745305 61.646012-228.41934 0.058328-86.614683-23.066345-163.023934-61.588707-228.361011z"
            fill=""
            p-id="3600"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          t="1646646108014"
          class="icon"
          viewBox="0 0 200 400"
          version="1.1"
          p-id="3599"
          style="
            enable-background: new 0 0 200 406;
            width: 30px;
            opacity: 0.5;
            position: fixed;
            right: 20px;
            top: 20px;
            z-index: 99;
          "
          @click="play"
        >
          <path
            class="st1"
            d="M102.8,226.7l-45,28.9H35.3c-12.5,0-22.6,10-22.6,22.5v45.1c0,12.4,10,22.5,22.6,22.5h22.5l45,28.9  c6.4,2.8,11.3-0.2,11.3-6.5v-135C114.1,226.9,109,224,102.8,226.7z"
          />
          <path
            class="st1"
            d="M188.3,321.4c2.9,2.9,2.9,7.7,0,10.6c-1.5,1.5-3.4,2.2-5.3,2.2s-3.8-0.7-5.3-2.2l-20.8-20.8L136.1,332  c-1.5,1.5-3.4,2.2-5.3,2.2c-1.9,0-3.8-0.7-5.3-2.2c-2.9-2.9-2.9-7.7,0-10.6l20.8-20.8l-20.8-20.8c-2.9-2.9-2.9-7.7,0-10.6  c2.9-2.9,7.7-2.9,10.6,0l20.8,20.8l20.8-20.8c2.9-2.9,7.7-2.9,10.6,0c2.9,2.9,2.9,7.7,0,10.6l-20.8,20.8L188.3,321.4z"
          />
        </svg>

        <img
          @click="showRule"
          v-maidian="'ruleClick'"
          src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/update/rule.png"
          id="ruleBtn"
          class="ruleBtn"
        />
        <img
          style="height: 49px; margin-top: 15px"
          src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/lottery/123.png"
          alt=""
        />
        <img
          style="width: 100%; margin-top: 15px"
          src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/three.png"
          alt=""
        />
        <div class="koreaSwiper">
          <div class="swiper-container">
            <div class="swiper-wrapper" style="width: 337px !important">
              <div class="swiper-slide slide-1">
                <img
                  style="margin-top: 30px"
                  :src="
                    chinaCity == 'beijing'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/1.png'
                      : chinaCity == 'chengdu'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/2.png'
                      : chinaCity == 'kunming'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/5.png'
                      : chinaCity == 'chongqing'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/7.png'
                      : chinaCity == 'shanghai'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/6.png'
                      : chinaCity == 'guangzhou'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/3.png'
                      : chinaCity == 'haerbin'
                      ? 'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/china/chinacity/4.png'
                      : ''
                  "
                  alt=""
                />
                <div
                  style="
                    width: 50px;
                    height: 20px;
                    position: absolute;
                    right: 108px;
                    top: 36px;
                  "
                  @click="showCity"
                ></div>
              </div>
              <div class="swiper-slide slide-2">
                <!-- <img style="margin-left: -60px;" 
                    :src="
                    koreaCity == 'SEOUL' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/se.png'
                      : koreaCity == 'ANTON' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/ad.png'
                      : koreaCity == 'KANGNUNG' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/jl.png'
                      : koreaCity == 'JNMC' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/qz.png'
                      : koreaCity == 'BUSAN' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/fs.png'
                      : koreaCity == 'MUQING' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/mp.png'
                      : koreaCity == 'JEJU' 
                      ?'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/jz.png'
                      : ''
                  " alt=""/> -->
                <div class="cityBox">
                  <span
                    v-show="activeKeys[key] == key"
                    v-for="(item, key) in imgList"
                    :key="key"
                  >
                    <img class="cityBg" :src="item" alt="" />
                    <i :class="key + '-btn'"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lightUpBtn cuyuan" @click="getMoreLotteryTime">
          <img
            src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/update/lightUp.png"
          />
        </div>
        <div class="zhunyuan laveCount">*剩余次数{{ time }}次</div>
        <div style="position: relative">
          <img
            class="lightCity"
            style="margin-top: 17px; width: 327px"
            src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/lottery/light_up.png"
            alt=""
          />
          <div class="koreaCityBox" id="koreaCityBox">
            <div class="koreaCityFlex">
              <div
                class="koreaCity"
                v-for="(item, index) in prize"
                v-if="index < 3"
                :key="index"
                @click="showKorea(item.cityCode)"
              >
                {{ item.name }}
                <div class="countLight">{{ item.num }}</div>
              </div>
            </div>
            <div class="koreaCityFlex">
              <div
                class="koreaCity"
                v-for="(item, index) in prize"
                v-if="index >= 3"
                :key="index"
                @click="showKorea(item.cityCode)"
              >
                {{ item.name }}
                <div class="countLight">{{ item.num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative; margin-top: 15px">
          <img
            style="width: 95%"
            src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/update/cj-1.png"
          />
          <div
            v-maidian="'lottery'"
            class="lotteryBtn"
            @click="joinLottery"
          ></div>
        </div>
      </div>
      <div class="box2">
        <img
          src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/9.png"
          class="travelnotesTit appointTit"
          alt=""
        />
        <div class="travelAll">
          <div
            class="travelBox"
            v-for="(item, index) in travelData"
            :key="index"
          >
            <img :src="item.img" class="travelImg" alt="" />
            <div class="travelBottom">
              <div class="travelTitle cuyuan">{{ item.title }}</div>
              <div class="travelContent zhunyuan">{{ item.content }}</div>
              <a
                href="javascript:void(0)"
                @click="goView(item.link)"
                alt=""
                class="viewNow"
                >立即查看</a
              >
            </div>
          </div>
        </div>
        <img
          src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/hotel/5.png"
          class="travelnotesTit appointTit"
          alt=""
        />
        <div>
          <hotelSwiper :audioPlayStatus="audioPlayStatus"></hotelSwiper>
          <a
            href="javascript:void(0)"
            @click="
              goView(
                'https://touch.qunar.com/intl/web/hotel-list?city=%E9%A6%96%E5%B0%94&cityUrl=i-seoul&checkInDate=2022-04-20&checkOutDate=2022-04-22'
              )
            "
            alt=""
            class="seeMore zhunyuan"
            >查看更多</a
          >
        </div>
        <div class="couponBox">
          <a
            v-maidian="'hotel'"
            href="javascript:void(0)"
            @click="
              goView(
                'https://m.flight.qunar.com/shark/active/ddc30231bd4e8ed8edb4b8b8046fda32'
              )
            "
            ><img
              src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/2.png"
              alt=""
              class="coupon"
          /></a>
          <a
            v-maidian="'flight'"
            href="javascript:void(0)"
            @click="
              goView(
                'https://qmall.qunar.com/qmall/#/productDetail?flightOrderNo=&footTag=buyButton&hybridid=f_shoppingMall_hy&moduleId=639069&pid=001008474872&sourceFrom=mall&_k=gh9k4f'
              )
            "
            ><img
              src="https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/3.png"
              alt=""
              class="coupon"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from "./components/banner.vue";
import appoint from "./components/appoint.vue";
import videoComp from "./components/video.vue";
import test from "./components/test.vue";
import loginDialog from "./components/dialog/login/index";
import giftDialog from "./components/dialog/gift/gift";
import ruleDialog from "./components/dialog/rule/index";
import cityDialog from "./components/dialog/city/index";
import { shareToPlatform } from "@/utils/hybird";
import { Tabbar, TabItem } from "mint-ui";
import citySwiper from "./components/citySwiper.vue";
import hotelSwiper from "./components/hotelSwiper.vue";
import createAudio from "./components/dialog/audio.js";
import shareDialog from "./components/dialog/share/index";
import openBox from "./components/dialog/gift/openBox";
import openLottery from "./components/dialog/gift/openLottery";
import lightDialog from "./components/dialog/light/index";

export default {
  components: {
    banner,
    appoint,
    videoComp,
    test,
    Tabbar,
    TabItem,
    citySwiper,
    hotelSwiper,
  },
  data() {
    return {
      lotteryStatus: false,
      chinaCity: "beijing",
      koreaCity: "SEOUL",
      time: 0,
      hasLogin: false,
      mangheList: [0, 0, 0, 0, 0, 0, 0, 0],
      videoList: [
        {
          src: "https://picbed.qunarzz.com/5cdcbd9dc557ef4310c43b1cb7b0d9d6.mp4",
          poster:
            "https://picbed.qunarzz.com/14e03d75b855e25b78b5364808b9d1c9.jpg",
        },
        {
          src: "https://picbed.qunarzz.com/980ba4e3eb67eec9602b1d17c4ffebc1.mp4",
          poster:
            "https://picbed.qunarzz.com/9d730be5faaaeb0c51f4c5493f0cf08d.jpg",
        },
      ],
      travelData: [
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/1.jpg",
          title: "3天2夜，玩转四季风景如画的江原道",
          content:
            "南怡岛的秋天将周边染成一片金黄，为游客呈现出如梦幻般的秋季景色。",
          link: "https://touch.travel.qunar.com/youji/7724987?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/2.jpg",
          title: "好友首尔两日趴趴走",
          content:
            "江南的狎鸥亭、清潭洞、论岘洞是众多明星居住的小区，也是大大小小的演艺企划公司密集的区域。",
          link: "https://touch.travel.qunar.com/youji/7724668?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/3.jpg",
          title: "恋人未满——首尔两日浪漫游",
          content:
            "你看过韩国电视剧《阳光先生（tvN，2018）》吗？在以20世纪初开化期的朝鲜为背景拍摄的电视剧里，一度成为热门话题的便是充满开化期浪漫色彩的主人公服饰。",
          link: "https://touch.travel.qunar.com/youji/7724755?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/4.jpg",
          title: "首尔一日美妆之旅",
          content:
            "这里几乎囊括了大多的化妆产品哦，价格便宜，所以如果喜欢化妆的话，一定要来看看哦！",
          link: "https://touch.travel.qunar.com/youji/7724768?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/5.jpg",
          title: "舌尖上的釜山美食两日游",
          content:
            "旅游除了去看风景外，还得去寻找当地的名食来满足自已的舌尖，来釜山就一定要来这些地方尝一尝！",
          link: "https://touch.travel.qunar.com/youji/7724842?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/6.jpg",
          title: "奢华釜山二日游",
          content:
            "釜山是世界上最繁忙的港口之一，历史上一直都是东亚大陆和海洋文化交流的纽带和桥梁。在这里你可以感受最高档的海洋休闲项目逛最具创意的画廊，品尝美食畅饮美酒的同时还可以俯瞰釜山美丽的海边夜景。",
          link: "https://touch.travel.qunar.com/youji/7724846?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/7.jpg",
          title: "与恋人开启浪漫济州二日游",
          content:
            "很喜欢济州岛这座城市，它也带给我很多意想不到的惊喜。但是我相信以后不管谁问我，济州岛怎么样啊，有意思吗，我都会说，这个城市值得来。",
          link: "https://touch.travel.qunar.com/youji/7724857?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/8.jpg",
          title: "与家人开启美好济州二日之旅",
          content:
            "和家人一起出去玩,最重要就是舒适的感觉,济州岛一个大小老少都可以来得地方。",
          link: "https://touch.travel.qunar.com/youji/7725269?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/quanluo.jpg",
          title: "全罗南道——木浦小确幸之旅",
          content: "如果此时您选择全罗南道的话，定能完成一次“小确幸”之旅。",
          link: "https://touch.travel.qunar.com/youji/7726126?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/andong.jpg",
          title: "安东，韩国精神文化古都一日神游",
          content:
            "今年随着KTX emu号列车的开通，从首尔去安东的行程变得更加便利快捷了，本文就请随我们乘坐KTX emu列车前往安东访问最佳景点、感受传统文化气息吧。",
          link: "https://touch.travel.qunar.com/youji/7726081?bd_source=RN&showType=share",
        },
        {
          img: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/travelnotes/real.jpg",
          title: "Real韩国，全州一日游",
          content:
            "全州是韩国最具代表性的旅行圣地，是每个访韩的外国游客都感兴趣的地方。",
          link: "https://touch.travel.qunar.com/youji/7726111?bd_source=RN&showType=share",
        },
      ],
      prize: [
        {
          name: "首尔",
          cityCode: "SEOUL",
          num: 0,
        },
        {
          name: "安东",
          cityCode: "ANTON",
          num: 0,
        },
        {
          name: "江陵",
          cityCode: "KANGNUNG",
          num: 0,
        },
        {
          name: "全州",
          cityCode: "JNMC",
          num: 0,
        },
        {
          name: "釜山",
          cityCode: "BUSAN",
          num: 0,
        },
        {
          name: "木浦",
          cityCode: "MUQING",
          num: 0,
        },
        {
          name: "济州",
          cityCode: "JEJU",
          num: 0,
        },
      ],
      activeKeys: {},
      imgList: {
        bg: "https://source.qunarzz.com/site/images/wns/20220425-shijian-bg.png",
        SEOUL:
          "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-shouer.png",
        ANTON:
          "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-andong.png",
        KANGNUNG:
          "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-jiangling.png",
        JNMC: "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-quanzhou.png",
        BUSAN:
          "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-fushan.png",
        MUQING:
          "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-mupu.png",
        JEJU: "https://source.qunarzz.com/site/images/wns/20220425-shijianchen-jizhou.png",
      },
      swiperList: {
        swiper3: null,
      },
      audioPlayStatus: true,
    };
  },
  methods: {
    goView(url) {
      sessionStorage.setItem("audioPlayStatus", this.audioPlayStatus); //存储页码
      window.location.href = url;
      return false;
    },
    getCityNameByCode(code) {
      let name = "";
      this.prize.forEach((item) => {
        if (item.cityCode == code) {
          name = item.name;
        }
      });
      return name;
    },
    stop() {
      document.getElementById("love_audio").pause();
      this.audioPlayStatus = false;
    },
    play() {
      if (document.getElementById("love_audio")) {
        document.getElementById("love_audio").play();
        this.audioPlayStatus = true;
      } else {
        let index = Math.random() + 0.5;
        if (index > 1) {
          createAudio("love", true, "love_audio", "loop");
        } else {
          createAudio("start", true, "love_audio", "loop");
        }
        this.audioPlayStatus = true;
      }
    },
    audioPlay() {
      if (this.audioPlayStatus) {
        let index = Math.random() + 0.5;
        if (index > 1) {
          createAudio("love", true, "love_audio", "loop");
        } else {
          createAudio("start", true, "love_audio", "loop");
        }
      }
    },
    showCity() {
      cityDialog({
        chinaCity: this.chinaCity,
        audioPlayStatus: this.audioPlayStatus,
      });
    },
    showKorea(data) {
      this.swiperList.swiper3.slideTo(1, 0, false);
      this.koreaCity = data;
      cityDialog({ chinaCity: data, audioPlayStatus: this.audioPlayStatus });
    },
    switchCity(data) {
      this.chinaCity = data.chinaCity;
      this.swiperList.swiper3.slideTo(0, 0, false);
    },
    lotteryByTimesResult(res, bool) {
      if (!bool) {
        openBox({
          callback: (done) => {
            done();
            cityDialog({
              chinaCity: res.data.code,
              audioPlayStatus: this.audioPlayStatus,
            });
            this.getNum();
            this.getAllWinRecord();
            this.swiperList.swiper3.slideTo(1, 1000, false);
          },
        });
      }else{
        cityDialog({
          chinaCity: res.data.code,
          audioPlayStatus: this.audioPlayStatus,
        });
        this.getNum();
        this.getAllWinRecord();
        this.swiperList.swiper3.slideTo(1, 1000, false);
      }
    },
    // getResult(){
    //   let res = {"success":true,"code":200,"message":null,"data":{"name":"安东","code":"ANTON","activityCode":"SKRCITY_202202","winRecordId":1057839,"virtualPrize":false,"ext":"{\"ANTON\":false}"}};
    //   return new Promise((resolve)=>{
    //     resolve(res)
    //   })
    // },
    lotteryByTimes() {
      this.$axios.post("/changmatwo/lotteryByTimes").then((res) => {
        if (res.code == 400) {
          loginDialog({
            callback: () => {
              this.hasLogin = true;
              this.getNum();
              this.getAllWinRecord(callback);
            },
          });
        } else if (res.code != 200) {
          this.$dialog.alert({
            message: res.message,
          });
        } else {
          this.koreaCity = res.data.code;
          let ext = JSON.parse(res.data.ext);
          if (ext[res.data.code] && !ext.seven) {
            lightDialog({
              city: this.getCityNameByCode(res.data.code),
              callback: (done) => {
                done();
                this.lotteryByTimesResult(res,true);
              },
            });
          } else {
            this.lotteryByTimesResult(res);
          }
        }
      });
    },
    // 点亮--抽取城市卡片
    getMoreLotteryTime() {
      if (this.hasLogin) {
        if (this.time > 0) {
          this.lotteryByTimes();
        } else {
          this.lotteryByTimes();
        }
      } else {
        loginDialog({
          callback: () => {
            this.hasLogin = true;
            this.getNum();
            this.getAllWinRecord();
          },
        });
      }
    },
    // 分享增加次数
    addTime() {
      this.$axios
        .get("/changmatwo/addnumfx?source=fx", {
          source: "fx",
        })
        .then((res) => {
          if (res.code == 400) {
            loginDialog({
              callback: () => {
                this.addTime();
              },
            });
          } else {
            this.getNum();
          }
        });
    },
    // 查询奖品--城市卡片
    getAllWinRecord(callback) {
      this.$axios.get("/changmatwo/getAllWinRecord").then((res) => {
        if (res.code == 400) {
          // loginDialog({
          //   callback: () => {
          //     this.hasLogin = true;
          //     this.getNum()
          //     this.getAllWinRecord(callback);
          //   },
          // });
        } else if (res.code != 200) {
          this.$dialog.alert({
            message: res.message,
          });
        } else {
          let data = res.data;
          this.getLightUpNum();
          this.activeKeys = {};
          data.forEach((item) => {
            this.prize.forEach((i) => {
              if (item.prizeCode == i.cityCode) {
                i.num += 1;
                this.activeKeys[item.prizeCode] = item.prizeCode;
              }
            });
          });
        }
      });
    },
    // 参与抽奖
    joinLottery() {
      if (this.hasLogin) {
        this.getAllWinRecord();
        let lotteryStatus = this.prize.every((item) => {
          // 判断是否可以抽奖
          return item.num > 0;
        });

        if (lotteryStatus) {
          openLottery({
            callback: (done) => {
              done();
              this.lotteryFn().then(() => {
                done();
              });
            },
          });
        } else {
          this.lotteryFn().then(() => {
            done();
          });
        }
      } else {
        loginDialog({
          callback: () => {
            this.hasLogin = true;
            this.getNum();
            this.getAllWinRecord(callback);
            // this.init().then(() => {
            //   this.joinLottery();
            // });
          },
        });
      }
    },
    // 参与抽奖
    lotteryFn() {
      return new Promise((resolve) => {
        this.init().then(() => {
          this.$axios
            .post(
              "/changmatwo/lottery",
              {},
              { headers: { "Activity-Code": "SKRMONEY_202202" } }
            )
            .then((res) => {
              if (res.code == 400) {
                loginDialog({
                  callback: () => {
                    this.hasLogin = true;
                    this.getNum();
                    this.getAllWinRecord();
                    // this.lotteryFn();
                  },
                });
              } else if (res.code != 200) {
                this.$dialog.alert({
                  message: res.message,
                });
              } else {
                resolve();
                this.getNum();
                this.getAllWinRecord();
                giftDialog({
                  winRecordId: res.data.winRecordId,
                  giftTip: res.data.code,
                });
              }
            });
        });
      });
    },
    // 初始化卡片数量
    getLightUpNum() {
      this.prize.forEach((item) => {
        item.num = 0;
      });
    },
    // 获取抽奖次数
    getNum() {
      this.$axios.get("/changmatwo/getchannelnum").then((res) => {
        if (res.code == 400) {
          this.hasLogin = false;
        } else {
          this.hasLogin = true;
          this.time = res.data.zs;
        }
      });
    },
    // 分享
    share() {
      shareToPlatform(
        () => {
          this.addTime();
        },
        () => {
          shareDialog({});
          this.addTime();
        }
      );
    },
    // 显示规则
    showRule() {
      ruleDialog({});
    },
    init() {
      return new Promise((resolve) => {
        this.$axios.get("/changmatwo/getchannelnum").then((res) => {
          if (res.code == 400) {
            this.hasLogin = false;
            resolve();
          } else {
            this.hasLogin = true;
            resolve();
          }
        });
      });
    },
  },
  mounted() {
    var audio_status = sessionStorage.getItem("audioPlayStatus");
    if (null !== audio_status && "" !== audio_status) {
      //恢复数据
      var audio_boolean = audio_status.toLowerCase() == "false" ? false : true;
      this.audioPlayStatus = audio_boolean;
      console.log("回退", this.audioPlayStatus);
      //删除缓存
      sessionStorage.removeItem("audioPlayStatus");
    }
    // lightDialog({
    //   city:this.getCityNameByCode("ANTON")
    // })
    this.getNum();
    this.getAllWinRecord();
    this.$nextTick(() => {
      this.swiperList.swiper3 = new Swiper(".koreaSwiper .swiper-container", {
        loop: false, // 循环模式选项
      });
    });
    // giftDialog({
    //   winRecordId: "aa",
    //   giftTip: "111",
    // });
  },
};
</script>
<style lang='less' scoped='true'>
@font-face {
  font-family: "zaozigongfang";
  src: url("https://source.qunarzz.com/site/images/wns/zaozigongfang.ttf");
}
@font-face {
  font-family: "zhunyuan";
  src: url("https://source.qunarzz.com/site/images/wns/zhunyuan.TTF");
}
@font-face {
  font-family: "cuyuan";
  src: url("https://source.qunarzz.com/site/images/wns/cuyuan.ttf");
}
.zaozigongfang {
  font-family: "zaozigongfang";
}
.zhunyuan {
  font-family: "zhunyuan";
}
.cuyuan {
  font-family: "cuyuan";
}
.container {
  margin-left: 15px;
  margin-right: 15px;
  width: calc(100% - 30px);
}

.shareIcon {
  position: absolute;
  right: 0;
  width: 50px;
  top: 260px;
  img {
    position: relative;
    z-index: 9999;
  }
}

.slide-1 {
  width: 375px !important;
  position: relative;
  overflow: hidden;
  margin-left: -56px;
}
.slide-2 {
  overflow: hidden;
  margin-left: -20px;
  background: #fffcf0;
  position: relative;
  overflow: hidden;
}
.ruleBtn {
  z-index: 2;
  width: 30px;
  padding-top: 4px;
  padding-bottom: 4px;
  color: #fff;
  font-size: 13px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: -28px;
}
#main {
  overflow: auto;
  height: 3100px;
  // height: 100vh;
  position: relative;
  background: #e6f4ee;
  .bg {
    position: relative;
  }

  .box {
    position: relative;
    background-color: #e6f4ee;
    padding-bottom: 50px;
  }
  .box2 {
    padding-left: 19px;
    padding-right: 19px;
    position: relative;
    background: #e6f4ee;
  }

  .lotteryBox {
    background: #fffcf0;
    padding: 0 18px 18px;
    .lightUpBtn {
      width: 91px;
      margin: 0 auto;
    }

    .lightCity {
      margin-top: 17px;
      width: 327px;
    }

    .laveCount {
      font-size: 10px;
      font-family: FZZhunYuan-M02S;
      font-weight: 400;
      color: #683c04;
      line-height: 10px;
    }

    .lotteryBtn {
      position: absolute;
      width: 91px;
      height: 30px;
      border-radius: 15px;
      top: 0;
      left: calc(50% - 45px);
    }

    .lotteryTip {
      margin: 0 6px;
      font-size: 10px;
      font-family: FZZhunYuan-M02S;
      font-weight: 400;
      color: #683c04;
      line-height: 15px;
      margin-top: 10px;
      text-align: left;
    }
  }

  .koreaCityBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    .koreaCityFlex {
      display: flex;
      margin-top: 5px;
    }
    .koreaCity {
      width: 47px !important;
      height: 25px !important;
      box-sizing: border-box;
      border-radius: 6px;
      font-size: 14px;
      font-weight: bold;
      color: #fffcf0;
      line-height: 28px;
      margin-right: 10px;
      // padding: 6px 12px;
      margin-top: 8px;
      background: #7dbf93;
      // border-radius: 6px;
      // font-size: 18px;
      // font-weight: bold;
      // color: #FFFCF0;
      position: relative;
      // margin-right: 10px;
      flex: none;
      .countLight {
        width: 15px;
        height: 15px;
        background: #ff7f28;
        border-radius: 50%;
        font-size: 10px;
        font-family: FZY4JW;
        font-weight: bold;
        color: #ffffff;
        line-height: 14px;
        position: absolute;
        top: -7px;
        right: -7px;
      }
    }
  }

  .koreaSwiper {
    width: 300px;
    margin-left: 37px;
  }

  .tit {
    width: 290px;
    margin-left: 14px;
    margin-bottom: 18px;
    margin-top: 20px;
    &-box {
      height: 70px;
    }
    &-big {
      width: 320px;
    }
    &-2 {
      width: 335px;
      margin-bottom: 0;
      position: relative;
      top: -22px;
    }
    &-3 {
      width: 320px;
      margin-bottom: 0;
    }
    &-4 {
      width: 288px;
    }
  }
  .submit {
    width: 220px;
    margin: 0 auto;
    margin-top: 6px;
  }
  .tip {
    margin-top: 5px;
    color: #232323;
  }
  .gift {
    &-box {
      margin-left: 16px;
      margin-right: 16px;
      img {
        margin-bottom: 11px;
      }
    }
    &-manghe {
      box-sizing: border-box;
      display: grid;
      grid-template-columns: repeat(4, calc(25% - 16px));
      grid-gap: 16px;
      &-box {
        height: 441px;
        background: url(https://s.qunarzz.com/srmweb/qunaradv/changma202201/1.png)
          no-repeat;
        background-size: 100% auto;
        padding: 40px 16px 0;
        padding-left: 35px;
        box-sizing: border-box;
      }
      .manghe {
        width: 59px;
        height: 148px;
      }
    }
  }
  .showTit {
    position: absolute;
    bottom: 50px;
    width: 320px;
    left: 50%;
    margin-left: -160px;
  }
  .jumpToMini {
    margin-top: 14px;
    width: 244px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 47px;
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      position: relative;
      top: 2px;
      background-color: #232323;
    }
  }
  .getMoreLotteryTime {
    width: 243px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 13px;
    margin-bottom: 27px;
  }
  .mt-swiper {
    height: 550px;
    /deep/ .mint-swipe-indicator {
      width: 21px;
      height: 2px;
      background: #1f1e1e;
      opacity: 1;
      &.is-active {
        background-color: #c2020a;
      }
    }
  }
  .container2 {
    height: 216px;
  }
}

.travelAll {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.travelBox {
  width: 161px;
  margin-top: 13px;
  border-radius: 4px;
  overflow: hidden;
}

.travelnotesTit {
  height: 49px;
  margin-bottom: 15px;
  margin-top: 20px;
}

.travelImg {
  width: 161px;
  height: 107px;
  vertical-align: middle;
}

.travelBottom {
  width: 100%;
  height: 94px;
  background: #fff;
  padding: 7px 12px 12px;
  box-sizing: border-box;
}

.travelTitle {
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  font-size: 11px;
  font-weight: 700;
}

.travelContent {
  font-size: 10px;
  font-weight: 400;
  color: #353535;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  word-break: normal;
}

.viewNow {
  text-decoration: none;
  width: 62px;
  height: 25px;
  background: #7dbf93;
  border-radius: 6px;
  font-size: 10px;
  font-family: FZZhunYuan-M02S;
  font-weight: 400;
  color: #fffcf0;
  display: inline-block;
  line-height: 25px;
  margin-top: 5px;
}

.seeMore {
  display: inline-block;
  padding-bottom: 2px;
  border-bottom: 2px solid #000;
  color: #000;
  text-decoration: none;
  margin-top: 11px;
}

.couponBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 337px;
  height: 167px;
  background: linear-gradient(180deg, #fcc81f 0%, #fc6801 100%);
  border-radius: 9px;
  margin-top: 14px;
}

.coupon {
  width: 130px;
  height: 141px;
}
.cityBox {
  width: 100%;
  height: 185px;
  background: url(https://source.qunarzz.com/site/images/wns/20220425-shijianchen-bg.png)
    no-repeat;
  background-size: 100% auto;
  position: relative;
  .cityBg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>